module.exports = __webpack_public_path__ + "static/media/galerija_2023 (8).b5eee770.png";